/*eslint-disable*/
import { useMemo, useState } from 'react'
import { Button } from '@/Components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/Components/ui/popover'
import { Input } from '@/Components/ui/input'
import { Check, ChevronDown, Search } from 'lucide-react'


const ParameterSelector = (props) => {
    const { parameters, handleQualityValueChange, qualityValue, tabType = null} = props;
    const [searchQuery, setSearchQuery] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const toggleParameter = (param) => {
        handleQualityValueChange(param);
        setIsOpen(false)
    }

    const selectAll = () => {
        handleQualityValueChange({
            id: null,
            name: 'All Parameters',
        });
        setIsOpen(false)
    }

    const renderList = useMemo(() => {
        if(tabType === 'statisticalAnalysis') {
            const filteredParameters = parameters.filter(param => param.inputType === 'number' || param.inputType === 'decimal');
            return {
                'AI Supervisor checks': [
                    { id: '-1', name: 'Defect check', selected: false },
                ],
                'UX App checklist': filteredParameters || []
            }
        } else {
            return {
                'AI Supervisor checks': [
                    { id: '1', name: 'Weight', selected: false },
                    { id: '2', name: 'Temperature', selected: false },
                    { id: '-1', name: 'Defect check', selected: false }
                ],
                'UX App checklist': parameters || []
            };
        }
    }, [tabType, parameters]);


    const generateData = () => {
        const filteredData = {};
            if (!searchQuery.trim()) {
                return renderList;
            }
            
            Object.entries(renderList).forEach(([category, params]) => {
                const filteredParams = params.filter(param => 
                    param.name.toLowerCase().includes(searchQuery.toLowerCase())
                );
                
                if (filteredParams.length > 0) {
                    filteredData[category] = filteredParams;
                }
            });    
        return filteredData;
    }

    return (
        <Popover open={isOpen} onOpenChange={setIsOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant='outline'
                    role='combobox'
                    aria-expanded={isOpen}
                    className='w-full justify-between border-gray-300'
                >
                    {qualityValue?.name || 'Select Parameter'}
                    <ChevronDown className='ml-2 h-4 w-4 shrink-0 opacity-50'/>
                </Button>
            </PopoverTrigger>
            <PopoverContent className='w-[300px] p-0'>
                <div className='px-3 py-2'>
                    <div className='relative'>
                        <Search className='absolute left-2 top-2.5 h-4 w-4 text-muted-foreground'/>
                        <Input
                            placeholder='Search parameter...'
                            className='pl-8'
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                </div>
                <div className='max-h-[300px] overflow-auto'>
                    {Object.entries(generateData()).map(([category, params]) => (
                        <div key={category}>
                            <div className='bg-muted px-3 py-1.5 text-sm text-slate-400 font-medium'>
                                {category}
                            </div>
                            {params.map((param) => (
                                <div
                                    key={param.id}
                                    className='flex items-center justify-between px-3 py-2 pl-10 hover:bg-muted cursor-pointer'
                                    onClick={() => toggleParameter(param)}
                                >
                                    <span>{param.name}</span>
                                    {param.id === qualityValue?.id && <Check className='h-4 w-4 text-black'/>}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
                {tabType !== 'statisticalAnalysis' && (
                    <div className='border-t px-3 py-2'>
                        <Button
                            variant='ghost'
                        className='w-full justify-between text-sm text-muted-foreground'
                        onClick={selectAll}
                    >
                        All parameters
                        <span>Select all</span>
                        </Button>
                    </div>
                )}
            </PopoverContent>
        </Popover>
    )
}

export default ParameterSelector;